
import React, { Component } from 'react';
import { Button, Tooltip } from '@material-ui/core';
import FileCopyOutlinedIcon from '@material-ui/icons/FileCopyOutlined';
import { CopyToClipboard } from 'react-copy-to-clipboard';


export default class CopyToClipboardButton extends Component {

  constructor(props) {
    super(props);

    this.state = {
      copied: false
    };

    this.ref = React.createRef();
  }

  handleCopied = () => {
    this.setState({
      copied: true
    });

    setTimeout(() => this.setState({copied: false}), 800);
  };

  render() {
    const { copied } = this.state;
    const { text, label, size, variant } = this.props;

    return (
      <Tooltip
        title="Скопировано"
        disableFocusListener
        disableHoverListener
        disableTouchListener
        open={copied}
      >
        <CopyToClipboard text={text} onCopy={() => this.handleCopied()}>
          <Button startIcon={<FileCopyOutlinedIcon />} size={size} variant={variant}>
            {label}
          </Button>
        </CopyToClipboard>
      </Tooltip>
    )
  }
}
